@if (previewContext) {
	@if (pageIndex === 0) {
		@if (isV4Layout) {
			<app-ts1-v4-report-summary
				[reportSummary]="reportSummary"
				[previewContext]="previewContext"
				[candidateId]="candidateId"
			></app-ts1-v4-report-summary>
		} @else {
			<app-ts1-v3-report-summary
				[reportSummary]="reportSummary"
				[previewContext]="previewContext"
				[candidateId]="candidateId"
			></app-ts1-v3-report-summary>
		}
	} @else if (hasManeuverBreakdown) {
		@if (isV4Layout) {
			<app-ts1-v4-maneuver-breakdown
				[reportSummary]="reportSummary"
				[previewContext]="previewContext"
				[maneuverBreakdownView]="reportSummary?.ts1V3PreviewSummary?.maneuverBreakdownView ?? []"
			></app-ts1-v4-maneuver-breakdown>
		} @else {
			<app-ts1-v3-maneuver-breakdown
				[reportSummary]="reportSummary"
				[previewContext]="previewContext"
				[maneuverBreakdownView]="reportSummary?.ts1V3PreviewSummary?.maneuverBreakdownView ?? []"
			></app-ts1-v3-maneuver-breakdown>
		}
	}
}
